<template>
  <v-dialog v-model="isOpenDialog" persistent max-width="500px">
    <v-card color="error">
      <v-card-title class="text-h1"></v-card-title>
      <v-card-text class="white--text text-h5">
        <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
        {{ errorMessage }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" text @click="closeDialog">
          {{ $t('common_close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',
  props: {},
  data: () => ({
    isOpenDialog: false,
    errorMessage: ''
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {
    closeDialog () {
      this.isOpenDialog = false
    },
    openDialog (val) {
      this.isOpenDialog = true
      this.errorMessage = val
    }
  }
}
</script>
